<template>
  <el-dialog
    title="编辑货代信息"
    :visible.sync="isShow"
    width="30%"
    :close-on-click-modal="false"
    destroy-on-close
    :before-close="closeDialog"
  >
    <el-form ref="form" :model="formData" :rules="rules" label-width="80px">
      <el-form-item label="货代编码" prop="forwarderCode">
        <el-input v-model="formData.forwarderCode" />
      </el-form-item>
      <el-form-item label="公司名称" prop="companyName">
        <el-input v-model="formData.companyName" />
      </el-form-item>
      <el-form-item label="联系人" prop="contactPerson">
        <el-input v-model="formData.contactPerson" />
      </el-form-item>
      <el-form-item label="电话" prop="phoneNumber">
        <el-input v-model="formData.phoneNumber" />
      </el-form-item>
      <el-form-item label="邮箱" prop="email">
        <el-input v-model.trim="formData.email" />
      </el-form-item>
      <el-form-item label="地址" prop="address">
        <el-input v-model="formData.address" />
      </el-form-item>
      <el-form-item label="状态" prop="isEnabled">
        <el-select v-model="formData.isEnabled" placeholder="请选择" style="width: 100%;">
          <el-option label="启用" :value="true" />
          <el-option label="停用" :value="false" />
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取消</el-button>
      <el-button type="primary" :loading="isLoading" @click="submitFormData">提交</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { freightForwardergetById, freightForwarderupdate } from '@/API/international';

export default {
  data () {
    return {
      isShow: false,
      isLoading: false,
      currentId: '',
      formData: { isEnabled: true },
      rules: {
        forwarderCode: [
          { required: true, message: '请输入货代编码', trigger: 'blur' }
        ],
        companyName: [
          { required: true, message: '请输入公司名称', trigger: 'blur' }
        ],
        contactPerson: [
          { required: true, message: '请输入联系人', trigger: 'blur' }
        ],
        phoneNumber: [
          { required: true, message: '请输入联系人', trigger: 'blur' }
        ],
        email: [
          { required: true, pattern: /^([a-zA-Z0-9]+[_|.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[.|-]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,4}$/, message: '请输正确的邮箱', trigger: 'blur' }
        ],
        address: [
          { required: true, message: '请输入地址', trigger: 'blur' }
        ]
      }
    };
  },
  methods: {
    openDialog (id) {
      this.currentId = id;
      this.queryDetail(id);
      this.isShow = true;
    },

    closeDialog () {
      this.isShow = false;
      this.formData = { isEnabled: true };
    },

    queryDetail (id) {
      freightForwardergetById({ id }).then(res => {
        let { status, data } = res.data;
        if (status === '200' && data) {
          this.formData = {
            forwarderCode: data.forwarderCode,
            companyName: data.companyName,
            contactPerson: data.contactPerson,
            phoneNumber: data.phoneNumber,
            email: data.email,
            address: data.address,
            isEnabled: data.isEnabled
          };
        }
      });
    },

    submitFormData () {
      let params = {
        id: this.currentId,
        ...this.formData
      };
      freightForwarderupdate(params)
        .then(res => {
          let { status, data } = res.data;
          if (status === '200' && data) {
            this.closeDialog();
            this.$emit('on-ok');
            this.$message.success('编辑成功');
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
};
</script>
